import React from 'react';

const useIsFormDirty = (formData: Record<string, unknown>, resetKey?: unknown): boolean => {
    const origHashRef = React.useRef(JSON.stringify(formData));
    const [isDirty, setIsDirty] = React.useState(false);

    React.useEffect(() => {
        origHashRef.current = JSON.stringify(formData);
        setIsDirty(false);
    }, [resetKey]);

    React.useEffect(() => {
        setIsDirty(JSON.stringify(formData) !== origHashRef.current);
    }, [formData]);

    return isDirty;
};

export default useIsFormDirty;
